import React from 'react'

const AdminUpdates = () => {
  return (
    <div>AdminUpdates</div>
  )
}

export default AdminUpdates